<template>
  <v-container fill-height fluid>
    <v-row align="center" justify="center">
      <v-col cols="12" class="text-center">
        <div class="pa-8">
          <v-img
            v-if="companyLogo"
            :src="companyLogo"
            contain
            max-height="150"
            max-width="300"
            class="mb-8 mx-auto"
          />
          
          <v-icon v-else size="150" color="white" class="mb-8">
            mdi-domain
          </v-icon>
          
          <h1 class="text-h3 font-weight-light mb-4">
            ¡Bienvenido{{ userName ? ', ' + userName : '' }}!
          </h1>
          
          <p class="text-h6 text--lighten-1 mb-0">
            Has iniciado sesión correctamente en el sistema.
          </p>
          
          <v-icon size="80" color="green" class="mt-8">
            mdi-check-circle-outline
          </v-icon>
        </div>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import SettingsMixin from "@/mixins/SettingsMixin.vue";

export default {
  name: "Welcome",
  mixins: [SettingsMixin],
  data() {
    return {
      userName: "",
      companyLogo: null,
    };
  },
  mounted() {
    this.loadUserData();
  },
  methods: {
    loadUserData() {
      // Obtener nombre del usuario
      this.userName = localStorage.getItem("name") || "";
      
      // Obtener logo de la compañía desde settings
      if (this.settings && this.settings.logo_url) {
        this.companyLogo = this.settings.logo_url;
      }
    },
  },
};
</script>

<style scoped>
.v-container {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  min-height: 100vh;
}
</style>
